import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Tabs } from '../root/components/common'
import ChooseLocations from './choose-locations'
import ChooseDevices from './choose-devices'
import ChooseReports from './choose-reports'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    tabs: {
        marginBottom: 15
    }
}))

export default function ChooseEntities(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, p, user, locale } = useSelector(state => state.main)

    const tabs = {
        locations: {
            key: 'locations',
            name: locale.sharing.locations
        },
        devices: {
            key: 'devices',
            name: locale.sharing.devices
        },
        reports: {
            key: 'reports',
            name: locale.sharing.reports
        }
    }

    const [currentTab, setCurrentTab] = useState(tabs.locations.key)

    return (
        <div className={classes.wrapper}>
            <Tabs
                className={classes.tabs}
                tabs={tabs}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
            />
            {currentTab === tabs.locations.key &&
                <ChooseLocations/>
            }
            {currentTab === tabs.devices.key &&
                <ChooseDevices/>
            }
            {currentTab === tabs.reports.key &&
                <ChooseReports/>
            }
        </div>
    )
}
